/* eslint-disable no-console */
/* eslint-disable no-unused-vars */

const ipLoopBack = `${process.env.VUE_APP_URL}`

const toBase64 = file => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => {
    resolve(reader.result);
  } 
  reader.onerror = error => reject(error);
});

function recognizeImpl (base64Bytes, url, kwargs = {}, headers) {
  return new Promise(function (resolve, reject) {
    try {
      fetch(
        url,
        {
          method: 'POST',
          mode: 'cors',
          body: base64Bytes ? JSON.stringify({data: base64Bytes, ...kwargs}) : JSON.stringify({...kwargs}),
          headers: headers ?  headers : {
            'Content-Type': 'application/json'
          },
          timeout: 30
        }
      ).then((response) => {
        return response.json()
      }
      ).then((ret) => {
        if (ret.code && ret.code != 0) {
          reject('인식 서버 오류, code: ' + ret.code)
          return
        }
        if (ret.status && ret.status != 0) {
          reject('인식 서버 오류, code: ' + ret.code)
          return
        }
        resolve(ret)
      }).catch(error => reject(error + ''));
    } catch (e) {
      reject('timeout')
    }
  })
}

async function recognizeMathExpression (file, isFile, isCanvas) {
  if (file == null) { // health check
    const ret = await recognizeImpl(base64Bytes, `${ipLoopBack}/api/experimental/mathexpression`, { isCanvas });
    return ret;
  }

  let base64Bytes;
  if (isFile == true)
    base64Bytes = await toBase64(file);
  else
    base64Bytes = file;
  const ret = await recognizeImpl(base64Bytes, `${ipLoopBack}/api/experimental/mathexpression`, { isCanvas });
  
  return {data: ret.data};
}

async function recognizeMathExpression2 (file, isFile, isCanvas) {
  if (file == null) { // health check
    const ret = await recognizeImpl(base64Bytes, `${ipLoopBack}/api/ocr/math/inference`, { isCanvas });
    return ret;
  }

  let base64Bytes;
  if (isFile == true)
    base64Bytes = await toBase64(file);
  else
    base64Bytes = file;
  const ret = await recognizeImpl(base64Bytes, `${ipLoopBack}/api/ocr/math/inference`, { isCanvas });
  
  return {data: ret.data};
}

export default {
  recognizeMathExpression,
  recognizeMathExpression2,
}
